export enum AccountPathsEnum {
  ACCOUNT = "/manage-profile",
  SECURITY = "/manage-profile/security",
  NOTIFICATION = "/manage-profile/notification",
  BILLING = "/manage-profile/usage-billing",
  ORG_SETTING = "/manage-profile/org-billing",
  PREFERENCES = "/manage-profile/preferences",
}
